var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 64c-8.122 0-15.754-3.162-21.498-8.902s-8.902-13.376-8.902-21.494c0-8.122 3.162-15.754 8.902-21.498s13.376-8.906 21.498-8.906c8.122 0 15.754 3.162 21.498 8.906s8.902 13.376 8.902 21.498c0 8.122-3.162 15.754-8.902 21.494s-13.376 8.902-21.498 8.902zM30.4 6.4c-14.998 0-27.2 12.202-27.2 27.2s12.202 27.2 27.2 27.2c14.998 0 27.2-12.202 27.2-27.2s-12.202-27.2-27.2-27.2z",
    fill: "#4F813D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 46.4c-0.41 0-0.819-0.157-1.133-0.467l-9.6-9.6c-0.624-0.624-0.624-1.638 0-2.262s1.638-0.624 2.262 0l8.467 8.467 21.267-21.267c0.624-0.624 1.638-0.624 2.262 0s0.624 1.638 0 2.262l-22.4 22.4c-0.314 0.314-0.723 0.467-1.133 0.467h0.006z",
    fill: "#4F813D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucces);
export default __webpack_public_path__ + "static/media/succes.9d7c13fea1f70a5d35c0406fd5fbc104.svg";
export { ForwardRef as ReactComponent };